import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { QuestionModel } from '../../../../shared/models/faq.model';
import { SharedModule } from '../../../../shared/shared.module';
import { AddEditQuestionComponent } from '../add-edit-question/add-edit-question.component';
import { TopicQuestionComponent } from '../topic-question/topic-question.component';

@Component({
  selector: 'app-blog-faq',
  standalone: true,
  imports: [
    AddEditQuestionComponent,
    InputWrapperComponent,
    TopicQuestionComponent,
    SharedModule,
    ModalComponent,
  ],
  templateUrl: './blog-faq.component.html',
  styleUrl: './blog-faq.component.scss',
})
export class BlogFaqComponent {
  @Input() blogForm!: FormGroup;
  editQuestionIndex = -1;
  showQuestionModal = false;
  constructor() {}
  faqSubmit(data: QuestionModel) {
    const { answer, question } = data;
    if (this.editQuestionIndex > -1) {
      const faqus = this.blogForm?.get('blogFaqs')?.value;
      faqus[this.editQuestionIndex] = {
        ...faqus[this.editQuestionIndex],
        answer,
        question,
      };
      this.editQuestionIndex = -1;
      this.blogForm?.get('blogFaqs')?.patchValue(faqus);
    } else {
      const faqus = this.blogForm?.get('blogFaqs')?.value || [];
      faqus.push({ answer, question });
      this.blogForm?.get('blogFaqs')?.patchValue(faqus);
    }
    this.toggleQuestionModal(false);
  }
  onEditQuestion(index: number) {
    this.editQuestionIndex = index;
    this.toggleQuestionModal(true);
  }

  deleteQuestion(index: number) {
    const faqus = this.blogForm?.get('blogFaqs')?.value || [];
    faqus?.splice(index, 1);
    this.blogForm?.get('blogFaqs')?.patchValue(faqus);
  }
  close() {
    this.editQuestionIndex = -1;
    this.toggleQuestionModal(false);
  }
  toggleQuestionModal(state: boolean) {
    this.showQuestionModal = state;
  }
  get questions() {
    return [...(this.blogForm?.get('blogFaqs')?.value || [])];
  }

  get editQuestion() {
    return this.editQuestionIndex > -1
      ? this.blogForm.get('blogFaqs')?.value[this.editQuestionIndex]
      : null;
  }
}
